import { ConceptualAbstractionSystem } from '../conceptualAbstraction';

// Convert conceptual archetype energies/influence to external boosts for ArchetypeEngine
export function computeArchetypeBoostsFromConceptual(system: ConceptualAbstractionSystem): Record<string, number> {
    const boosts: Record<string, number> = {};
    if (!system || typeof (system as any).getArchetypes !== 'function') return boosts;
    try {
        const archetypesMap: Map<string, any> = (system as any).getArchetypes?.() || (system as any).conceptualSpace?.archetypes;
        if (!archetypesMap) return boosts;
        for (const [id, a] of archetypesMap as any) {
            const energy = clamp01(a?.energy ?? 0);
            const influence = clamp01(a?.influence ?? 0);
            const boost = clamp01(0.6 * energy + 0.4 * influence);
            boosts[id] = boost; // direct key alignment (e.g., 'the_void')
        }
        // Provide mappings to classic categories when names overlap
        aliasBoost(boosts, 'magician_creator', boosts['magician']);
    } catch {
        // ignore
    }
    return boosts;
}

function aliasBoost(boosts: Record<string, number>, toKey: string, value?: number) {
    if (typeof value === 'number') boosts[toKey] = Math.max(boosts[toKey] || 0, value);
}

function clamp01(x: number): number { return x < 0 ? 0 : x > 1 ? 1 : x; }


